export default "__VITE_ASSET__2dEH_8L___"